import Button from 'molecules/Button';
import DropDown from 'molecules/Dropdown';

import useEventListingStore, { clearEventFilters, updateEventFilters } from 'layout/Listing/variants/events/store';

import { hasArrayValues } from 'utils/array/arrays';

import eventTags from 'data/eventTags.json';

import type { FC } from 'react';

interface EventFiltersProps {}

const EventFilters: FC<EventFiltersProps> = () => {
  const filter = useEventListingStore(state => state.filters);
  const search = useEventListingStore(state => state.search);

  return (
    <>
      {(hasArrayValues(filter) || search.length > 0) && (
        <Button hierarchy="linkGray" startIcon="x-circle" label="Clear Filters" onClick={clearEventFilters} />
      )}
      <DropDown
        placeholder="Filter by category"
        options={eventTags}
        value={filter}
        onChange={e => updateEventFilters(e as string[])}
        multiple
      />
    </>
  );
};

export default EventFilters;
